import {injectable} from 'inversify';
import {KeycloakLoginOptions, KeycloakPromise} from 'keycloak-js';
import {BehaviorSubject} from 'rxjs';
import {GlobalContainerTypes} from '../../../types';
import {AuthStrategyFactory} from './auth-strategy.factory';
import {AuthLifecycle, AuthStrategy} from './auth-strategy.types';
import {Auth, AuthState, Profile} from './auth.types';

@injectable()
class AuthService implements Auth, AuthLifecycle {
  public static readonly type = GlobalContainerTypes.Auth;

  public initialized: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public authenticated: BehaviorSubject<boolean> = new BehaviorSubject(null);

  private readonly strategy: AuthStrategy;

  public constructor() {
    this.login = this.login.bind(this);
    this.logout = this.logout.bind(this);
    this.strategy = AuthStrategyFactory.create(this);
  }

  public login(options?: KeycloakLoginOptions): void {
    this.strategy.login(options);
  }

  public logout(): void {
    this.strategy.logout();
  }

  public updateToken(): KeycloakPromise<boolean, boolean> {
    return this.strategy.updateToken();
  }

  public get authState(): AuthState {
    return this.strategy.authState;
  }

  public get userProfile(): Profile {
    return this.strategy.userProfile;
  }
}

export default AuthService;
